"use client";

import { Manrope, Albert_Sans } from "next/font/google";

const manrope = Manrope({
  variable: "--font-manrope",
  subsets: ["latin"],
  display: "swap",
  preload: false,
});

const albertSans = Albert_Sans({
  variable: "--font-albertSans",
  subsets: ["latin"],
  display: "swap",
  preload: false,
});

export default function ClientFontLoader() {
  return (
    <style jsx global>{`
      :root {
        ${manrope.variable}: ${manrope.style.fontFamily};
        ${albertSans.variable}: ${albertSans.style.fontFamily};
      }
    `}</style>
  );
}
